export default [
    {
        name: "بانک آینده",
        card_code: "636214",
        code: '062',
        db: 6,
    },
    {
        name: "بانک اقتصاد نوین",
        card_code: "627412",
        code: '055',
        db: 15,
    },
    {
        name: "بانک انصار",
        card_code: "627381",
        code: '063',
        db: 26,
    },
    {
        name: "بانک ایران زمین",
        card_code: "505785",
        code: '069',
        db: 36,
    },
    {
        name: "بانک پارسیان",
        card_code: "622106",
        code: '054',
        db: 5,
    },
    {
        name: "بانک پارسیان",
        card_code: "627884",
        code: '054',
        db: 5,
    },
    {
        name: "بانک پاسارگاد",
        card_code: "502229",
        code: '057',
        db: 3,
    },
    {
        name: "بانک پاسارگاد",
        card_code: "639347",
        code: '057',
        db: 3,
    },
    {
        name: "پست بانک ایران",
        card_code: "627760",
        code: '021',
        db: 13,
    },
    {
        name: "بانک تجارت",
        card_code: "585983",
        code: '018',
        db: 24,
    },
    {
        name: "بانک تجارت",
        card_code: "627353",
        code: '018',
        db: 24,
    },
    {
        name: "بانک توسعه تعاون",
        card_code: "502908",
        code: '022',
        db: 14,
    },
    {
        name: "بانک توسعه صادرات",
        card_code: "207177",
        code: '020',
        db: 9,
    },
    {
        name: "بانک توسعه صادرات",
        card_code: "627648",
        code: '020',
        db: 9,
    },
    {
        name: "بانک حکمت ایرانیان",
        card_code: "636949",
        code: '065',
        db: 37,
    },
    {
        name: "بانک خاورمیانه",
        card_code: "585949",
        db: 32,
    },
    {
        name: "بانک خاورمیانه",
        card_code: "585947",
        db: 32,
    },
    {
        name: "بانک دی",
        card_code: "502938",
        code: '066',
        db: 22,
    },
    {
        name: "بانک رسالت",
        card_code: "504172",
        code: '070',
        db: 30,
    },
    {
        name: "بانک رفاه کارگران",
        card_code: "589463",
        code: '013',
        db: 25,
    },
    {
        name: "بلو بانک",
        card_code: "62198619",
        db: 33,
    },
    {
        name: "بانک سامان",
        card_code: "62198610",
        code: '056',
        db: 17,
    },
    {
        name: "بانک سامان",
        card_code: "62198615",
        code: '056',
        db: 17,
    },
    {
        name: "بانک سامان",
        card_code: "62198617",
        code: '056',
        db: 17,
    },
    {
        name: "بانک سامان",
        card_code: "62198618",
        code: '056',
        db: 17,
    },
    {
        name: "بانک سپه",
        card_code: "589210",
        code: '015',
        db: 8,
    },
    {
        name: "بانک سرمایه",
        card_code: "639607",
        code: '058',
        db: 19,
    },
    {
        name: "بانک سینا",
        card_code: "639346",
        code: '059',
        db: 18,
    },
    {
        name: "بانک شهر",
        card_code: "502806",
        code: '061',
        db: 21,
    },
    {
        name: "بانک شهر",
        card_code: "504706",
        code: '061',
        db: 21,
    },
    {
        name: "بانک صادرات ایران",
        card_code: "603769",
        code: '019',
        db: 23,
    },
    {
        name: "بانک صادرات ایران",
        card_code: "903769",
        code: '019',
        db: 23,
    },
    {
        name: "بانک صنعت و معدن",
        card_code: "627961",
        code: '011',
        db: 10,
    },
    {
        name: "بانک قرض الحسنه مهر",
        card_code: "639370",
        db: 27,
    },
    {
        name: "بانک قوامین",
        card_code: "639599",
        code: '052',
        db: 31,
    },
    {
        name: "بانک کارآفرین",
        card_code: "627488",
        code: '053',
        db: 16,
    },
    {
        name: "بانک کشاورزی",
        card_code: "603770",
        code: '016',
        db: 11,
    },
    {
        name: "بانک کشاورزی",
        card_code: "639217",
        code: '016',
        db: 11,
    },
    {
        name: "بانک گردشگری",
        card_code: "505416",
        code: '064',
        db: 28,
    },
    {
        name: "بانک گردشگری",
        card_code: "505426",
        code: '064',
        db: 28,
    },
    {
        name: "بانک مرکزی ایران",
        card_code: "636797",
        code: '010',
        db: 38,
    },
    {
        name: "بانک مرکزی ایران",
        card_code: "636795",
        code: '010',
        db: 38,
    },
    {
        name: "بانک مسکن",
        card_code: "628023",
        code: '014',
        db: 12,
    },
    {
        name: "بانک ملت",
        card_code: "610433",
        code: '012',
        db: 4,
    },
    {
        name: "بانک ملت",
        card_code: "991975",
        code: '012',
        db: 4,
    },
    {
        name: "بانک ملی ایران",
        card_code: "170019",
        code: '017',
        db: 7,
    },
    {
        name: "بانک ملی ایران",
        card_code: "603799",
        code: '017',
        db: 7,
    },
    {
        name: "بانک مهر ایران",
        card_code: "606373",
        code: '060',
        db: 29,
    },
    {
        name: "بانک مهر ایران",
        card_code: "606373",
        code: '090',
        db: 29,
    },
    {
        name: "موسسه کوثر",
        card_code: "505801",
        db: 39,
    },
    {
        name: "موسسه اعتباری ملل",
        card_code: "606256",
        db: 34,
    },
    {
        name: "موسسه اعتباری توسعه",
        card_code: "628157",
        code: '051',
        db: 40,
    },
    {
        name: "بانک تات",
        card_code: "636214",
        db: 20,
    },
    {
        name: "موسسه نور",
        card_code: "507677",
        db: 35,
    },
    {
        name: "بانک کاسپین",
        card_code: "55555555",
        db: 41,
    },
    {
        name: "بانک ایران و اروپا",
        card_code: "44444444",
        db: 42,
    },
];
